import { Link } from 'react-router-dom';

import { Page } from '@app/routes';
import { FooterLink } from '@app/shared/ui/molecules/Layout';
import { defaultTelegramVibrate } from '@app/shared/utils/common';
import { homeWhiteIcon } from '@app/assets';
import { FOOTER_HEIGHT } from '@app/shared/constants/layout';

export function Footer() {
  return (
    <footer
      className="fixed bottom-0 flex z-100 pt-[6px] w-full max-w-[480px] bg-footer shadow-[0_-4px_20px_#0000000f]"
      style={{
        minHeight: FOOTER_HEIGHT,
        paddingBottom:
          'calc(env(safe-area-inset-bottom, 0px) + var(--tg-safe-area-inset-bottom, 0px))',
      }}
    >
      <nav className="absolute  flex w-full items-end justify-between px-3">
        <FooterLink type="shop" onClick={defaultTelegramVibrate} />
        <FooterLink type="friends" onClick={defaultTelegramVibrate} />
        <div className="w-[60px] shrink-0" />
        <Link
          to={Page.HOME}
          className="absolute -top-6 left-1/2 z-50 -translate-x-1/2 transition-transform duration-200 hover:scale-110"
          onClick={defaultTelegramVibrate}
        >
          <img src={homeWhiteIcon} alt="home" className="h-[72px] w-[72px]" />
        </Link>
        <FooterLink type="cognition" onClick={defaultTelegramVibrate} />
        <FooterLink type="tasks" onClick={defaultTelegramVibrate} />
      </nav>
    </footer>
  );
}
